import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { ThreadSummary } from '@core/tellent-assistant-types';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DividerComponent,
  DropdownComponent,
  DropdownItemComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-thread-drawer',
  standalone: true,
  imports: [
    ButtonComponent,
    ConnectedOverlayDirective,
    DividerComponent,
    DropdownComponent,
    DropdownItemComponent,
    IconButtonComponent,
    IconComponent,
    OverlayOriginDirective,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'complementary' },
  templateUrl: './tellent-assistant-thread-drawer.component.html',
  styleUrl: './tellent-assistant-thread-drawer.component.less',
})
export class TellentAssistantThreadDrawerComponent {
  private readonly i18n = inject(I18nService);

  protected readonly defaultTitle = this.i18n.translate(
    'tlc.tellent_assistant.thread.default_title',
  );
  protected readonly menuOpenForThread = signal<string | null>(null);
  protected readonly menuPositions = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
  ] satisfies ConnectionPositionPair[];

  public readonly threads = input.required<readonly ThreadSummary[]>();
  public readonly activeId = input<string | null>(null);
  public readonly isDeleting = input<(threadId: string) => boolean>(() => false);
  public readonly newThread = output<void>();
  public readonly selectThread = output<string>();
  public readonly deleteThread = output<string>();
  public readonly pinThread = output<{ id: string; pinned: boolean }>();
  public readonly helpCenter = output<void>();
  public readonly intelligenceSettings = output<void>();

  protected onKebabClick(threadId: string, _origin: OverlayOriginDirective, event: Event): void {
    event.stopPropagation();
    this.menuOpenForThread.set(threadId);
  }

  protected onPinClick(thread: ThreadSummary): void {
    this.menuOpenForThread.set(null);
    this.pinThread.emit({ id: thread.id, pinned: !thread.pinned });
  }

  protected onRemoveClick(threadId: string): void {
    this.menuOpenForThread.set(null);
    this.deleteThread.emit(threadId);
  }
}
